import { setupPsiConfig } from './psi';
import { setupSccApi } from './scc';
import { setupTcfApi } from './tcf';
import { version } from './version';
import { loadMessagingScript, loadExternalToolsScript } from './utils/index';

export function psi(window, document, navigator, config) {
    loadExternalToolsScript(document);
    setupPsiConfig(window, document, navigator, {...config, jsSdkVersion: version});
    loadMessagingScript(config, document);
}

export function scc(window, document, navigator, config) {
    loadExternalToolsScript(document);
    setupPsiConfig(window, document, navigator, config);
    setupSccApi(window, config);
    loadMessagingScript(config, document);
}

export function tcf(window, document, navigator, config) {
    loadExternalToolsScript(document);
    setupPsiConfig(window, document, navigator, config, 'tcf');
    setupTcfApi(window, config);
    loadMessagingScript(config, document, true);
}
